// extracted by mini-css-extract-plugin
export default {"richtext":"lsf-richtext","richtext__container":"lsf-richtext__container","richtext__orig-container":"lsf-richtext__orig-container","richtext__work-container":"lsf-richtext__work-container","richtext__iframe":"lsf-richtext__iframe","richtext__orig-iframe":"lsf-richtext__orig-iframe","richtext__work-iframe":"lsf-richtext__work-iframe","richtext__loading":"lsf-richtext__loading"};
    if(module.hot) {
      // 1637785525817
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  